import { useCallback, useState } from "react";
import type { DocumentUploadOptions } from "@/types";

const DEFAULT_UPLOAD_OPTIONS: DocumentUploadOptions = {
	extractEntities: true,
	extractRelationships: true,
	generateFormal: true,
	validateExpressions: true,
};

interface UseUploadOptionsReturn {
	uploadOptions: DocumentUploadOptions;
	toggleOption: (option: keyof DocumentUploadOptions, checked: boolean) => void;
	resetUploadOptions: () => void;
}

export const useUploadOptions = (): UseUploadOptionsReturn => {
	const [uploadOptions, setUploadOptions] = useState<DocumentUploadOptions>(DEFAULT_UPLOAD_OPTIONS);

	const toggleOption = useCallback((option: keyof DocumentUploadOptions, checked: boolean) => {
		setUploadOptions((prev) => ({
			...prev,
			[option]: checked,
		}));
	}, []);

	const resetUploadOptions = useCallback(() => {
		setUploadOptions(DEFAULT_UPLOAD_OPTIONS);
	}, []);

	return {
		uploadOptions,
		toggleOption,
		resetUploadOptions,
	};
};

export default useUploadOptions;
